import { company } from '../data/content';
import usePageMeta from '../hooks/usePageMeta';

export default function Company() {
  usePageMeta({
    title: 'Pulmakivi - Suomalainen mobiilipeliyritys',
    description: 'Pulmakivi on helsinkiläinen mobiilipeliyritys, joka kehittää Norppa-ristikkosovellusta suomenkieliselle yleisölle.',
    canonical: 'https://pulmakivi.fi/yritys',
  });

  return (
    <div className="company-info">
      <h1 className="page__title">{company.name}</h1>
      <p>{company.description}</p>
      <p>
        Yhteydenotto: <a href={`mailto:${company.email}`}>{company.email}</a>
      </p>
    </div>
  );
}
